module.exports = __webpack_public_path__ + "static/media/oxy-snacks.bca7a8cf.jpeg";